// Versão do Admin HML derivada automaticamente do package.json —
// não editar manualmente; basta atualizar a versão no package.json.
import pkg from '../../../../../package.json';

export const APP_VERSION: string = pkg.version;
export const APP_BUILD_LABEL = `Admin HML v${APP_VERSION}`;
